import { useContext } from 'react';
import { BrandingContext } from './BrandingProvider';
import type { BrandingContextValue } from './types';
import { featureEnabled } from './registry';

/** Renvoie le branding du tenant courant. À utiliser dans un `<BrandingProvider>`. */
export function useBranding(): BrandingContextValue {
  const ctx = useContext(BrandingContext);
  if (!ctx) {
    throw new Error('useBranding doit être utilisé dans un <BrandingProvider>');
  }
  return ctx;
}

/**
 * Renvoie l'état d'un feature flag pour le tenant courant.
 * @param key clé du flag (ex. `'carteCadeau'`)
 * @param defaultValue valeur si la clé est absente (défaut `false`)
 */
export function useFeatureFlag(key: string, defaultValue = false): boolean {
  const { features } = useBranding();
  return featureEnabled(features, key, defaultValue);
}
